export default __webpack_public_path__ + "media/images/delete-12e30f475a630de80bd4bff792eb912d.png";